const onClickBlogItem = () => window.scroll({ behavior: 'smooth', top: 0 });

const formattedDate = (date, locale = 'id-ID') => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  const dated = new Date(date);
  return dated.toLocaleDateString(locale, options);
};

export { onClickBlogItem, formattedDate };
